import React from 'react';
import { Card, Collapse } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const ResultRow = ({ title, value }) => (
  <>
    <Card.Title>{title}</Card.Title>
    <Card.Text className="result">{value}</Card.Text>
  </>
);

const ResultStatusCard = ({ result, scoreType }) => {
  return (
    <div>
      <Collapse in={true}>
        <Card className="mt-3">
          <Card.Body>
            {result.status === 'pending' && (
              <>
                <Card.Title>
                  {I18n.t(`euro_smr_score_widget.show.pending`)}
                </Card.Title>
                <Card.Text>
                  <span className="spinner"></span>
                </Card.Text>
              </>
            )}

            {result.status === 'error' && (
              <>
                <Card.Title>
                  <i className="fas fa-exclamation-triangle" aria-hidden="true" />
                  {/*<FontAwesomeIcon icon={faExclamationTriangle} />*/}
                  &nbsp;Error
                </Card.Title>
                <Card.Text>
                  {result.error_message ||
                    I18n.t('euro_smr_score_widget.error.default_error_message')}
                </Card.Text>
              </>
            )}

            {result.status === 'completed' && (
              <>
                <ResultRow
                  title={
                    scoreType === 'SMR'
                      ? I18n.t(`euro_smr_score_widget.show.completed_smr`)
                      : I18n.t(`euro_smr_score_widget.show.completed_tr`)
                  }
                  value={parseFloat(result.calculated_score).toFixed(2)}
                />

                {scoreType === 'SMR' && (
                  <>
                    <ResultRow
                      title={I18n.t(
                        `euro_smr_score_widget.show.risk_1yr_mortality_title`
                      )}
                      value={result.risk_1yr_mortality}
                    />
                    <ResultRow
                      title={I18n.t(
                        `euro_smr_score_widget.show.risk_1yr_mortality_nyha_iii_title`
                      )}
                      value={result.risk_1yr_mortality_or_nyha_ge_iii}
                    />
                    <ResultRow
                      title={I18n.t(
                        `euro_smr_score_widget.show.risk_1yr_mortality_nyha_iv_title`
                      )}
                      value={result.risk_1yr_mortality_or_nyha_iv}
                    />
                  </>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Collapse>
    </div>
  );
};

export default ResultStatusCard;
